




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SEE_ORIGINAL_PRICE } from '@/models/account/Permission';

@Component
export default class ProductPrice extends Vue {
    @Prop({ required: true })
    public price!: number;

    @Prop({ required: true })
    public pricePerUnit!: number;

    @Prop({ required: true })
    public inPrice!: number;

    @Prop({ required: true })
    public inPricePerUnit!: number;

    @Prop({ required: true })
    public disabled!: boolean;

    get getPrice (): number {
        return !this.disabled && this.price > 0
            ? this.price
            : 0;
    }

    get getPricePerUnit (): number {
        return !this.disabled && this.pricePerUnit > 0
            ? this.pricePerUnit
            : 0;
    }

    get getInPrice (): number {
        return !this.disabled && this.inPrice > 0
            ? this.inPrice
            : 0;
    }

    get getInPricePerUnit (): number {
        return !this.disabled && this.inPricePerUnit > 0
            ? this.inPricePerUnit
            : 0;
    }

    get canSeeOriginalPrice (): boolean {
        return this.$store.getters['auth/hasPermission'](SEE_ORIGINAL_PRICE);
    }
}
